import React, { Component } from "react";
import { Grid, Row, Col, Media, FormControl, FormGroup } from "react-bootstrap";

import Card from "../../components/Card/Card.jsx";

import Button from "../../components/CustomButton/CustomButton.jsx";

class UnderConstructionPage extends Component {
  render() {
    return (
      <Grid>
        <Row>
          <Col md={8} mdOffset={2}>
            <div className="header-text">
              <h2>Under Construction</h2>
              <h4>Sorry for the inconvience, this page is under construction and will be finished soon. Check back with us!</h4>
              <hr />
            </div>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default UnderConstructionPage;



// WEBPACK FOOTER //
// ./src/views/Pages/UnderConstructionPage.jsx